<template>
  <label :for="id" class="container">
    <!-- A Label for checkbox -->
    <span :v-if="title" class="label">{{ title }}</span>
    <input :id="id" type="checkbox" :value="value" v-model="proxyChecked" />
    <span :class="theme === 'light' ? 'checkmark' : 'checkmark dark'"></span>
  </label>
</template>

<script>
export default {
  /**
   *
   * @title for the checkbox label
   * @theme to match theme type @light or @dark
   * @value for the checkbox
   * @click emit the change of value
   *
   */
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    id: String,
    // click: Event,
    theme: String,
    title: String,
    checked: {
      type: [Array, Boolean],
      default: false
    },
    value: {
      default: null
    },
  },
  computed: {
    proxyChecked: {
      get() {
        return this.checked;
      },
      set(val) {
        this.$emit('change', val);
        this.$emit('click', val);
      }
    }
  }
};
</script>
<style scoped>
/* The container */
.container {
  display: block;
  position: relative;
  margin-top: 4px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.label {
  margin-left: 20px;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;

  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;

  left: 0;
  height: 18px;
  width: 18px;
  top: 50%;
  transform: translateY(-50%);
  background-color: #f4f4f5;
}
x
/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 4px;
  width: 10px;
  bottom: 2px;
  height: 22px;
  border: solid black;
  border-width: 0 2.5px 2.5px 0;
  -webkit-transform: rotate(35deg);
  -ms-transform: rotate(35deg);
  transform: rotate(35deg) skew(10deg, 10deg);
}

/* Style for dark theme checkmark background */
.dark {
  border: 1px solid rgba(244, 244, 245, 0.5);

  background-color: transparent;
}

/* Style for dark theme checkmark */
.container .dark:after {
  border: solid #f4f4f5;
  border-width: 0 2.5px 2.5px 0;
}
</style>
